import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../../app-token.service";
import { HttpHandlerService } from "../../http-handler.service";

@Injectable()

export class ChargesService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'rates';
    _upload_EndPoint = 'charges/upload';
    // _uploadDetails_EndPoint = 'charge/upload/details';
    _fuelSurcharges_EndPoint = 'charges/fuel-surcharges';
    _oda_EndPoint = 'charges/oda';
    _getPincodeOda_EndPoint = 'charges/oda/pincode';
    _awbCharges_EndPoint = 'charges/mapping/awb/charges';
    _getChargesResourceEndPoint = 'charges';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAll(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}?pagelimit=${params?.length}&pageoffset=${params?.start}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/list?pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetById(chargesId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/${chargesId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
    
    public getChargePeriodById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/upload/period/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Add(chargesData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            chargesData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Update(chargesData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            chargesData
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Delete(chargesId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/${chargesId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetByChargeType(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._upload_EndPoint}/${data}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    // public Upload_GetAllList(data: any): Observable<any> {
    //     const full_api_url = `${this._apiUrl}${this._upload_EndPoint}/charges`;
    //     const request_options = this._httpHandler.prepareRequest(
    //         'POST',
    //         full_api_url,
    //         data
    //     );
    //     return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    // }

    public Upload_Update(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/upload`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Upload_Delete(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._upload_EndPoint}/info/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }


    public GetDetailsById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/details/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddDetails(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/details`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateDetails(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/details`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public DeleteDetails(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/details/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public FuelSurcharges_GetAll(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._fuelSurcharges_EndPoint}/charges`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public FuelSurcharges_Add(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._fuelSurcharges_EndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public FuelSurcharges_Update(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._fuelSurcharges_EndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public FuelSurcharges_Delete(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._fuelSurcharges_EndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllPeriods(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/periods`
        if (params?.refresh) {
            full_api_url = full_api_url + `?refresh=${new Date().getTime()}`;
        }

        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public CheckChargePeriod(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/periods/check`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetChargePeriodByTypeId(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._upload_EndPoint}/periods/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetChargeInfoByPeriod(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/info/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public UploadCharge(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/upload`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UpdateChargePeriodById(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/periods`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public DeleteChargePeriodById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/periods/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllTypes(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/types`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public IsExist_ODA(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getPincodeOda_EndPoint}`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllODA(params: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._oda_EndPoint}?pagelimit=${params.length}&pageoffset=${params.start}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public SearchODA(params: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._oda_EndPoint}/search`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            params
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetODAById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._oda_EndPoint}/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public AddODA(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._oda_EndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateODA(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._oda_EndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public DeleteODA(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._oda_EndPoint}/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAWBCharges(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._awbCharges_EndPoint}`;
        const request_option = this._httpHandler.prepareRequest('POST', full_api_url, data);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetApplicableCharges(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getChargesResourceEndPoint}/applicable`;
        const request_option = this._httpHandler.prepareRequest('POST', full_api_url, data);
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }
}
